import { currentPostedDate } from '@fruitful/fruitils';
import { subYears } from 'date-fns';
import * as React from 'react';
import { useState } from 'react';
import {
    DateRangeSelectionSheet,
    LabelRegular,
    PillButton,
    ScreenContainer,
    XStack,
    YStack,
} from 'smoothie';

import { format, tomorrow } from '../../../../common/utils/dateUtils';
import useGetAccountDisplayDetailsFromGlobalState from '../../../hooks/useGetAccountDisplayDetailsFromGlobalState';
import TransactionTable from './transactionTable/TransactionTable';

interface PaymentHistoryProps {
    syncteraAccountId: string;
}

const PaymentHistory = ({ syncteraAccountId }: PaymentHistoryProps) => {
    const defaultToDate = currentPostedDate();
    const defaultFromDate = subYears(defaultToDate, 1);

    const { account } = useGetAccountDisplayDetailsFromGlobalState({
        syncteraAccountId,
    });

    const [toDate, setToDate] = useState(defaultToDate);
    const [fromDate, setFromDate] = useState(defaultFromDate);
    const [isDateSelectionSheetOpen, setIsDateSelectionSheetOpen] =
        useState(false);

    return (
        <ScreenContainer title="Payment history" hasBackButton>
            <YStack>
                <XStack gap="$4" justifyContent="space-between">
                    <PillButton
                        text="Filter by date range"
                        onPress={() => {
                            setIsDateSelectionSheetOpen(true);
                        }}
                        pillProps={{
                            alignSelf: 'flex-start',
                            marginVertical: 12,
                        }}
                    />
                    <LabelRegular
                        fontSize={14}
                        justifyContent="center"
                        alignSelf="center"
                    >
                        {`${format(fromDate, 'MMM d, yyyy')} - ${format(toDate, 'MMM d, yyyy')}`}
                    </LabelRegular>
                </XStack>
                <TransactionTable
                    bankAccountId={account?.bankAccountId as string}
                    syncteraAccountId={syncteraAccountId}
                    allowPagination={true}
                    fromDate={fromDate}
                    toDate={toDate}
                    isPaymentTransactionTable={true}
                />
            </YStack>
            <DateRangeSelectionSheet
                maximumDate={tomorrow()}
                defaultToDate={defaultToDate}
                defaultFromDate={defaultFromDate}
                isOpen={isDateSelectionSheetOpen}
                onClose={() => {
                    setIsDateSelectionSheetOpen(false);
                }}
                confirmButtonText="View transactions"
                onConfirm={(fromDate: Date, toDate: Date) => {
                    setFromDate(fromDate);
                    setToDate(toDate);
                    setIsDateSelectionSheetOpen(false);
                }}
            />
        </ScreenContainer>
    );
};

export default PaymentHistory;
